import React from 'react';
import * as PropTypes from 'prop-types';
import IconButton from './IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ImportExportIcon from '@material-ui/icons/ImportExport';
const ExportedInfoButton = ({ onClick, size, color, disabled, action, canBeExported, isexported }) => {

    const tooltip = canBeExported=== false ? 'Kundendaten nicht mit Datev synchronisiert! Kein Export möglich!' : isexported ? 'Rechnungsdaten bereits exportiert!' : 'Rechnungsdaten noch nicht exportiert!';

    return (
            <IconButton
                onClick={onClick}
                size={size}
                color={color}
                disabled={disabled}
                action={action}
            >
                <Tooltip title={tooltip} arrow>
                {!canBeExported
                    ? <ImportExportIcon style={{ color: 'grey' }} />
                    : isexported
                        ? <ImportExportIcon style={{ color: 'green' }} />
                        : <ImportExportIcon style={{ color: 'red' }} />
                }
                </Tooltip>
            </IconButton>

    );
};

ExportedInfoButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    size: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    action: PropTypes.string,
    canBeExported: PropTypes.bool.isRequired,
    isexported: PropTypes.bool.isRequired
};

ExportedInfoButton.defaultProps = {
    size: null,
    disabled: false,
    color: 'default',
    action: null,
    canBeExported: true,
    isexported: false,
};

export default ExportedInfoButton;
